import * as React from "react";
import { HRQuestionId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion } from "../../messages/HR";
import { GenericInputHeader } from "./GenericInputHeader";
import { ChangeEvent } from "react";
import "./GenericDocumentInput.css";
import { PlaceholderEmbeddedPDF } from "../placeholders/PlaceholderEmbeddedPDF";
import { MultipleImagesSelect } from "../widgets/MultipleImagesSelect";

interface GenericDocumentInputProps {
    hrDocumentQuestionWithStatus: HRQuestionWithStatus<HRQuestion.DocumentQuestion>;
    isHidden: boolean;
    onChange: (newVal: string | null, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

interface GenericDocumentInputState {
    documentType: "Image" | "PDF";
}

export class GenericDocumentInput extends React.Component<GenericDocumentInputProps, GenericDocumentInputState> {
    constructor(props: GenericDocumentInputProps) {
        super(props);

        let docType: "Image" | "PDF" = "Image";
        const ans = this.props.hrDocumentQuestionWithStatus.question.answer;
        if (ans && this.getUrlExtension(ans) === "pdf") {
            docType = "PDF";
        }
        this.state = {
            documentType: docType
        };
    }

    getUrlExtension(url: string): string {
        const ext = url.split(/\#|\?/)[0].split(".").pop();
        if (!ext) {
            return "";
        }
        return ext.trim();
    }

    renderImage(url: string) {
        return (
            <div
                style={{
                    background: `url(${url}) center / contain no-repeat`
                }}
                className={"GenericDocumentInput__fileUploadPreview"}
            />
        );
    }

    renderPdf(url: string) {
        return (
            <div id="GenericDocumentInput_pdfContainer">
                <PlaceholderEmbeddedPDF
                    pdfUrl={url}
                    containerElementId={"GenericDocumentInput_pdfContainer"}
                    widthScale={0.4}
                />
            </div>
        );
    }

    setDocumentType(docType: "Image" | "PDF") {
        this.setState({documentType: docType});
    }

    render() {
        const question = this.props.hrDocumentQuestionWithStatus.question;
        const status = this.props.hrDocumentQuestionWithStatus.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <GenericInputHeader status={status} questionText={question.questionText} />
                <MultipleImagesSelect
                    onSetDocumentType={(type: "Image" | "PDF") => this.setDocumentType(type)}
                    uploadPdf={(imagePdf) => {
                        const questionId = this.props.hrDocumentQuestionWithStatus.question.id;
                        this.props.onChange(imagePdf, questionId);
                        this.props.onBlur(questionId);
                    }
                    }
                />
                {question.answer === null ? null :
                    this.state.documentType === "PDF" ? this.renderPdf(question.answer) : this.renderImage(question.answer)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericDocumentInput.tsx